import { useEffect } from "react";
import Head from "next/head";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";

import SearchResource from "../src/components/booking/SearchResource";

import { getAllWorkSpaceRequest } from "../src/redux/workspace/WorkSpaceActions";
import Routes from "../src/routes/Routes";

const BookRessource = () => {
  const dispatch = useDispatch();
  const { query } = useRouter();

  const mWorkspace = useSelector(
    ({ workspace }) => workspace.workSpaceMap[query.spaceId]
  );

  useEffect(() => {
    !mWorkspace && dispatch(getAllWorkSpaceRequest());
  }, [mWorkspace]);

  return (
    <>
      <Head>
        <title>
          GO Bermondsey-Coworking Office Space in Bermondsey, London
        </title>
        <meta
          name="description"
          content="Beautifully designed premium coworking space in London with private offices,flexible and dedicated desks. Schedule a visit in Bermondsey, London at GO Bermondsey."
        />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link rel="canonical"
        href={`${Routes?.domain}${Routes?.availability}`}
        />
      </Head>

      <SearchResource />
    </>
  );
};

export default BookRessource;
